module.exports = __webpack_public_path__ + "static/media/v-fingers.b3c671dc.svg";